<template>
    <div>
        <h3>{{ (theme.name) ? (themeActivation ? 'Activate Gallery Theme' : 'Theme Settings') : 'Create A New Theme' }}</h3>
        <form class="large-form">
            <div class="form-line">
                <div class="form-field" id="form-field-name" style="width: 100%;">
                    <div v-if="themeActivation" class="small-note"><b>By activating a gallery theme</b> it will be copied to your theme libary and you will be able to use it in your suveys. You will also be able to customise it as you wish.</div>
                    <label for="form-input-name">Theme Name</label>
                    <input id="form-input-name" type="text" v-model="model.name" required>
                    <div v-if="themeActivation" class="field-note">You can customise the name of this theme for your theme library.</div>
                </div>
            </div>
            <div v-if="(!themeActivation && theme.name) || galleryMode" class="form-line">
                <div class="form-field" id="form-field-status">
                    <label for="form-input-status">Theme Status</label>
                    <WSSelect v-model="model.active" :options="[
                        {value: 'true', text: 'Active'},
                        {value: 'false', text: 'Inactive'},
                    ]" />
                </div>
            </div>
            <div v-if="galleryMode" class="form-line">
                <div class="form-field" id="form-field-category">
                    <label for="form-input-category">Category</label>
                    <WSSelect v-model="model.category_id" :options="[...categories, {id: 'new', name: '-- New Category --'}]" text-attr="name" value-attr="id" />
                </div>
            </div>
            <div v-if="model.category_id === 'new'" class="form-line">
                <div class="form-field" id="form-field-category-name">
                    <label for="form-input-category-name">Category Name</label>
                    <input v-model="model.category_name" type="text" id="form-input-category-name" required />
                </div>
            </div>
            <div v-if="galleryMode" class="form-line">
                <div class="form-field" id="form-field-description">
                    <label for="form-input-description">Description</label>
                    <textarea v-model="model.description" id="form-input-description" cols="30" rows="6" required></textarea>
                </div>
            </div>
            <div v-if="(!themeActivation && model.id)" style="text-align: right">
                <div class="ws-button ws-button-negative small" @click="onDelete">Delete Theme</div>
            </div>

        </form>
        <div class="form-actions">
            <div type="button" class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div type="submit" class="ws-button ws-button-main" @click="onSubmit">Save</div>
        </div>
    </div>
</template>

<script>

import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'SurveyThemeForm',
    components: {WSSelect},
    props: {
        theme: {
            type: Object,
            default: () => ({
                name: undefined,
                status: undefined,
                category_id: undefined,
                category_name: undefined,
                description: undefined,
                active: true,
            })
        },
        galleryMode: {
            type: Boolean,
            default: false
        },
        themeActivation: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: {
                name: undefined,
                status: undefined,
                category_id: undefined,
                category_name: undefined,
                description: undefined,
                active: true,
            }
        }
    },
    computed: {
        categories() {
            return this.$store.state.surveyThemesGallery.categories
        },
    },
    created() {
        this.resetModel();
        if(this.galleryMode){
            if (!this.theme.name) this.model.active = false;
            this.$store.dispatch('surveyThemesGallery/getCategories')
        }
    },
    methods: {
        onSubmit() {
            this.$emit('save', {
                ...this.model,
                category_id: this.model.category_id === 'new' ? undefined : this.model.category_id
            })
        },
        resetModel() {
            this.model = {...this.theme}
        },
        onCancel() {
            this.$emit('cancel')
        },
        async onDelete() {
            const store = this.galleryMode ? 'surveyThemesGallery' : 'surveyThemes';
            const route = this.galleryMode ? 'surveys-themes-gallery' : 'surveys-themes';
            await this.$store.dispatch(`${store}/delete`, this.model.id)
            this.$router.push({name: route})
        },
    },
}
</script>
